<!-- 饮食风险 -->
<template>
  <div>

		<div style="font-size: 16px;">
			基础体征
			<el-tag v-if="!basicFinished" type="danger" size="mini" style="margin-left: 10px">未完成</el-tag>
			<el-tag v-else size="mini" style="margin-left: 10px">已完成</el-tag>
		</div>

		<el-form ref="form" label-width="60px" :inline="true" :rules="rules" :model="form">
			<div class="exam-item">
				<div>
					<el-form-item label="身高" prop="height">
						<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.height"></el-input> cm
					</el-form-item>
					<el-form-item label="体重" prop="weight">
						<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.weight"></el-input> kg
					</el-form-item>
					<!-- <span style="margin-left: 10px;">BMI</span> <el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form7.bmi"></el-input> -->
				</div>

				<div class="item-name">
					相关评估 
					<!-- <i class="el-icon-warning"></i> -->
					<i class="el-icon-success"  v-if="otherData"></i>
				</div>
				<div>
					<el-form-item label="体力活动水平" label-width="120px" prop="sportLevel">
						<el-radio-group v-model="form.sportLevel">
							<el-radio :label="1">体力活动缺乏</el-radio>
							<el-radio :label="2">体力活动不足</el-radio>
							<el-radio :label="3">体力活动中等</el-radio>
							<el-radio :label="4">体力活动较多</el-radio>
						</el-radio-group>						
					</el-form-item>
					<!-- <span style="margin-left: 10px;">BMI</span> <el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form7.bmi"></el-input> -->
				</div>				
			</div>		
		</el-form>		

		<div style="text-align: center;">
			<el-button type="primary" :loading="isLoading" @click="onAssess">生成评估</el-button>
		</div>		
  </div>

</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import { EventBus } from '@/event-bus.js';
import dayjs from 'dayjs';

export default {  
	mixins: [mixin],
	props: {
		// 问卷是否已完成
		questSucc: Boolean,
		// 评估id
		id: Number,
		patientId: Number,
		// 其他参数
		otherData: Object		
	},
	data(){
		return {
			noSidebar: true,   
			isLoading: false,
			form: {dataId:0,dataType:3,measuringTime:'',patientId: 0, height: '', weight: '', sportLevel: undefined, bmi: '' },
			rules: {
				height: {required: true, message: '请输入', trigger: 'blur'},
				weight: {required: true, message: '请输入', trigger: 'blur'},
				sportLevel: {required: true, message: '请选择', trigger: 'change'},
			},
			filter:{
				patientId: 0,
				dataType: '',
				type:'',
				measuringTimeStart: '',
				measuringTimeEnd: '',
				date: [],
				pageNumber: 1,
				pageSize: 30
			},
			basic:{},
			basicFinished:false	
		}
	},
	watch: {
		form:{
			deep: true,
			handler(val, oldVal) {
				if(val.weight && val.height&& val.sportLevel){
					this.basicFinished=true;
				}else{
					this.basicFinished=false;
				}
			}
		}
	},
	mounted() {
		this.filter.patientId = this.patientId;
		this.form.patientId = this.patientId;
		this.getBasicData()
	}, 
	methods: {
		getBasicData(){
			// 获取身高体重
			api.getPatientLabBasic(this.filter).then(res => {
				if (res.code==1000) {
					if(res.data.length > 0){
						this.basic.weight = res.data[0].weight;
						this.basic.height = res.data[0].height;
						this.form.weight = this.basic.weight ? this.basic.weight : '';
						this.form.height = this.basic.height ? this.basic.height : '';
					}
				}else{
					this.$message.error(res.message);
				}
			});
		},
		async init() {
			this.form.height = this.otherData.height;
			this.form.weight = this.otherData.weight;
		},		
		async onAssess() {
			if(this.form.weight !=this.basic.weight) {
				this.editBasic('weight', this.form.weight);
			}else if(this.form.height !=this.basic.height) {
				this.editBasic('height', this.form.height);
			}
			if (!this.questSucc) {
				return this.$message.warning('请先完成评估问卷');
			}
			this.assessForm();
		},		
		async assessForm() {
			// examination
			if (this.isLoading) { return; }
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					this.isLoading = true;
					const res = await api.assessCustomerEval({id: this.id, params: { examination: this.form }});
					this.isLoading = false;
					if (res.code != 1000) {return this.$message.error(res.message);}
					this.$emit('succ');	
					EventBus.$emit('update-eval-data')
								
				}
			});
		},
		getBMI(){
			return (this.form.weight / Math.pow(this.form.height / 100, 2)).toFixed(1);
		},
		async editBasic(key, value) {
			const now=new Date().getTime();
			this.form.measuringTime=dayjs(now).format('YYYY-MM-DD HH:mm:ss');
			this.form.bmi = this.getBMI();
			let res=await api.addPatientLabBasic(this.form)
			this.getBasicData()
		},		
	}
}
</script>

